import { ButtonHTMLAttributes } from 'react'

export type FloatingButtonProps = ButtonHTMLAttributes<HTMLButtonElement>
